var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 541,
    height: 540,
    viewBox: "0 0 541 540",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_641_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.3994 474.324L73.8495 366.293L61.6116 367.559L60.7676 355.321L139.259 286.114L331.69 267.546L422.419 320.718L423.685 332.533L411.447 333.799L421.575 441.831L84.3994 474.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.829 278.497L331.804 267.505L345.297 275.424V240.382L280.942 175.958L216.587 240.382V279.536L217.829 278.497Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.586 461.753V493.814C233.658 476.736 256.804 467.143 280.938 467.143C305.072 467.143 328.218 476.736 345.289 493.814V449.348L216.586 461.753Z",
    fill: "#D7CDE0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8445 177.753C64.0579 177.753 55.5595 176.169 47.3491 173C39.2828 169.831 32.0087 165.15 25.5268 158.956C19.189 152.618 14.1475 144.768 10.4024 135.405C6.65735 126.042 4.78481 115.095 4.78481 102.564C4.78481 90.1761 6.65735 79.3009 10.4024 69.9382C14.1475 60.5755 19.261 52.7973 25.7429 46.6035C32.2247 40.2657 39.4988 35.5123 47.5652 32.3434C55.7755 29.0304 64.202 27.3739 72.8445 27.3739C81.631 27.3739 90.0574 28.9584 98.1238 32.1273C106.334 35.1522 113.608 39.8335 119.946 46.1714C126.428 52.3652 131.541 60.2154 135.286 69.7222C139.032 79.0849 140.904 90.032 140.904 102.564C140.904 114.807 139.032 125.682 135.286 135.189C131.541 144.552 126.428 152.402 119.946 158.74C113.608 164.934 106.334 169.687 98.1238 173C90.0574 176.169 81.631 177.753 72.8445 177.753ZM72.8445 173.216C80.7668 173.216 87.1766 171.127 92.074 166.95C96.9714 162.629 100.5 155.355 102.661 145.128C104.966 134.757 106.118 120.569 106.118 102.564C106.118 84.4144 104.966 70.2263 102.661 59.9994C100.5 49.6284 96.9714 42.3543 92.074 38.1771C87.1766 33.8558 80.7668 31.6952 72.8445 31.6952C65.0662 31.6952 58.7284 33.8558 53.831 38.1771C48.9336 42.3543 45.3325 49.6284 43.0279 59.9994C40.8672 70.2263 39.7869 84.4144 39.7869 102.564C39.7869 120.569 40.8672 134.757 43.0279 145.128C45.3325 155.355 48.9336 162.629 53.831 166.95C58.7284 171.127 65.0662 173.216 72.8445 173.216ZM204.194 177.105C193.246 177.105 183.74 174.873 175.673 170.407C167.607 165.798 161.341 159.316 156.876 150.962C152.555 142.607 150.394 132.812 150.394 121.577C150.394 110.342 152.699 100.619 157.308 92.4087C162.061 84.1984 168.471 77.8605 176.538 73.3952C184.748 68.9299 193.967 66.6973 204.194 66.6973C214.42 66.6973 223.567 68.9299 231.633 73.3952C239.7 77.7165 246.038 83.9823 250.647 92.1927C255.4 100.403 257.777 110.198 257.777 121.577C257.777 132.956 255.544 142.823 251.079 151.178C246.758 159.388 240.564 165.798 232.498 170.407C224.575 174.873 215.141 177.105 204.194 177.105ZM204.194 172.784C209.235 172.784 213.268 171.344 216.293 168.463C219.318 165.582 221.479 160.468 222.775 153.122C224.215 145.776 224.936 135.405 224.936 122.009C224.936 108.469 224.215 98.0264 222.775 90.6802C221.479 83.3341 219.318 78.2206 216.293 75.3398C213.268 72.459 209.235 71.0186 204.194 71.0186C199.152 71.0186 195.047 72.459 191.878 75.3398C188.853 78.2206 186.62 83.3341 185.18 90.6802C183.884 98.0264 183.235 108.469 183.235 122.009C183.235 135.405 183.884 145.776 185.18 153.122C186.62 160.468 188.853 165.582 191.878 168.463C195.047 171.344 199.152 172.784 204.194 172.784ZM265.157 223.559V221.398L267.75 220.534C273.079 219.093 275.744 215.636 275.744 210.163V92.6248C275.744 89.4559 275.168 87.0792 274.015 85.4947C273.007 83.9103 271.063 82.83 268.182 82.2538L265.157 81.6056V79.445L301.887 66.9134L304.048 69.074L305.993 75.7719C310.746 72.8911 316.004 70.6584 321.765 69.074C327.671 67.4895 333.721 66.6973 339.914 66.6973C352.302 66.6973 362.097 71.4507 369.299 80.9574C376.645 90.3201 380.318 103.788 380.318 121.361C380.318 138.646 376.285 152.258 368.219 162.197C360.296 172.136 349.061 177.105 334.513 177.105C323.134 177.105 313.555 175.449 305.777 172.136V209.515C305.777 215.276 308.369 218.877 313.555 220.318L317.66 221.398V223.559H265.157ZM324.142 170.839C331.344 170.839 337.034 167.094 341.211 159.604C345.532 152.114 347.693 139.654 347.693 122.225C347.693 104.796 345.676 92.6248 341.643 85.7108C337.61 78.6528 331.776 75.1237 324.142 75.1237C318.812 75.1237 312.907 76.8522 306.425 80.3092V167.382C311.898 169.687 317.804 170.839 324.142 170.839ZM427.447 177.105C420.389 177.105 414.051 176.241 408.433 174.512C402.816 172.928 397.63 170.911 392.877 168.463L393.093 142.751H395.253L402.6 155.715C405.768 161.477 409.225 165.798 412.971 168.679C416.86 171.416 421.757 172.784 427.663 172.784C434.577 172.784 440.122 171.272 444.3 168.247C448.621 165.078 450.781 160.901 450.781 155.715C450.781 150.962 449.269 147.073 446.244 144.048C443.219 141.023 437.602 138.286 429.391 135.837L420.317 133.028C411.53 130.436 404.616 126.403 399.575 120.929C394.533 115.455 392.013 108.757 392.013 100.835C392.013 91.3284 395.758 83.2621 403.248 76.6362C410.738 70.0103 421.469 66.6973 435.441 66.6973C441.059 66.6973 446.316 67.3455 451.214 68.6419C456.255 69.7942 461.08 71.5947 465.69 74.0434L464.393 97.3782H462.233L454.671 83.9823C451.934 79.2289 449.197 75.916 446.46 74.0434C443.867 72.0268 439.906 71.0186 434.577 71.0186C429.679 71.0186 425.07 72.387 420.749 75.1237C416.428 77.8605 414.267 81.7497 414.267 86.7911C414.267 91.6885 416.067 95.5776 419.669 98.4585C423.414 101.339 428.887 104.004 436.089 106.453L445.812 109.262C456.183 112.431 463.601 116.824 468.066 122.441C472.532 127.915 474.764 134.541 474.764 142.319C474.764 152.834 470.587 161.261 462.233 167.598C454.022 173.936 442.427 177.105 427.447 177.105ZM514.668 28.6703C519.998 28.6703 524.175 30.3988 527.2 33.8558C530.225 37.1688 531.737 41.5621 531.737 47.0356C531.737 51.5009 530.585 58.4869 528.28 67.9937C525.976 77.3564 523.599 87.7274 521.15 99.1067L516.613 121.793H512.508L507.97 99.1067C505.666 88.0155 503.361 77.7885 501.056 68.4258C498.752 58.9191 497.599 51.789 497.599 47.0356C497.599 41.5621 499.112 37.1688 502.137 33.8558C505.162 30.3988 509.339 28.6703 514.668 28.6703ZM514.668 177.105C509.339 177.105 504.874 175.305 501.273 171.704C497.672 168.103 495.871 163.709 495.871 158.524C495.871 153.482 497.672 149.161 501.273 145.56C504.874 141.815 509.339 139.942 514.668 139.942C519.854 139.942 524.247 141.815 527.848 145.56C531.449 149.161 533.25 153.482 533.25 158.524C533.25 163.709 531.449 168.103 527.848 171.704C524.247 175.305 519.854 177.105 514.668 177.105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_641_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M386.441 152.206C441.36 124.709 424.55 69.7161 386.441 69.7161C348.332 69.7161 331.529 124.73 386.441 152.206Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.441 152.206C441.36 124.709 424.55 69.7161 386.441 69.7161C348.332 69.7161 331.529 124.73 386.441 152.206Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.912 154.325L384.853 153.167C385.334 152.879 385.884 152.728 386.444 152.728C387.005 152.728 387.555 152.879 388.036 153.167L389.969 154.325",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.441 153.187V229.82C386.444 251.365 382.867 272.76 375.855 293.129",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.077 327.312L356.971 347.002L322.206 350.353L320.312 330.663C319.868 326.047 321.274 321.443 324.22 317.865C327.167 314.286 331.413 312.026 336.024 311.582C340.634 311.139 345.231 312.548 348.804 315.497C352.377 318.447 354.634 322.697 355.077 327.312Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M336.045 311.617C335.18 311.707 334.324 311.863 333.483 312.084C337.656 312.303 341.612 314.015 344.631 316.907C347.65 319.8 349.532 323.681 349.933 327.846L351.832 347.535L356.998 347.041L355.106 327.344C354.662 322.728 352.404 318.478 348.829 315.529C345.254 312.579 340.656 311.172 336.045 311.617Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.006 432.922L104.941 390.688L151.463 386.202L155.528 428.436",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.006 432.922L104.941 390.688L151.463 386.202L155.528 428.436",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M151.431 386.224L104.906 390.708L105.736 399.337L152.261 394.852L151.431 386.224Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.217 424.317L194.152 382.09L240.681 377.604L244.739 419.838",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.217 424.317L194.152 382.09L240.681 377.604L244.739 419.838",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M240.642 377.633L194.117 382.117L194.947 390.746L241.472 386.261L240.642 377.633Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.803 267.505L139.162 286.078L60.4526 355.512",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.803 267.505L139.162 286.078L60.4526 355.512",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.616 438.998L72.0122 475.693",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.919 455.932L265.67 338.959",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.351 325.013L421.6 441.986",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.2776 474.506L73.8823 366.42",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8496 366.293L84.3995 474.324L421.575 441.831L411.025 333.799L423.263 332.533",
    stroke: "black",
    strokeWidth: 0.843994
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.632 363.026L315.759 367.929L322.467 437.662L373.34 432.758L366.632 363.026Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.253 424.656L194.152 382.09L240.681 377.604L244.774 420.17",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.035 433.254L104.941 390.688L151.463 386.202L155.563 428.768",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.877 453.029C306.3 447.039 304.036 441.335 300.349 436.582L298.19 433.798C295.282 429.829 291.388 426.688 286.895 424.688C282.402 422.688 277.464 421.898 272.572 422.396C266.89 422.957 261.661 425.752 258.034 430.167C254.405 434.583 249.174 437.378 243.489 437.938L241.09 438.193C235.546 438.751 230.445 441.475 226.894 445.773C223.343 450.071 221.628 455.597 222.12 461.154L306.877 453.029Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.936 435.183L341.225 365.453",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.093 432.015L314.716 438.413L316.042 452.196L382.419 445.798L381.093 432.015Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.078 327.311L356.972 347.002L322.206 350.353L320.312 330.662C319.868 326.046 321.274 321.443 324.221 317.864C327.167 314.286 331.413 312.026 336.024 311.581V311.581C340.636 311.137 345.234 312.544 348.809 315.494C352.383 318.444 354.641 322.694 355.085 327.311L355.078 327.311Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.106 327.344L356.997 347.041L374.379 345.359L370.815 308.269C368.533 308.488 366.315 309.156 364.29 310.234C362.265 311.311 360.472 312.777 359.014 314.549C357.555 316.32 356.459 318.362 355.788 320.557C355.118 322.753 354.886 325.059 355.106 327.344V327.344Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.281 314.974L304.845 352.064L322.234 350.39L320.336 330.7C320.116 328.415 319.45 326.195 318.373 324.168C317.297 322.141 315.832 320.346 314.063 318.886C312.293 317.425 310.254 316.328 308.061 315.657C305.868 314.986 303.564 314.753 301.281 314.974V314.974Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.421 396.771L454.833 389.706C455.309 387.409 455.326 385.04 454.881 382.737C454.437 380.434 453.54 378.242 452.243 376.288C450.946 374.334 449.274 372.657 447.325 371.355C445.375 370.053 443.187 369.151 440.887 368.702C440.394 363.486 438.502 358.5 435.411 354.272C432.32 350.044 428.146 346.73 423.329 344.681C419.738 343.148 415.787 342.659 411.931 343.268C408.074 343.878 404.467 345.563 401.522 348.129L400.584 348.984C394.186 354.573 389.213 361.61 386.078 369.509C382.944 377.409 381.737 385.944 382.559 394.404C382.974 398.767 384.248 403.005 386.307 406.873C388.366 410.741 391.17 414.163 394.557 416.941C401.669 422.787 410.801 425.581 419.963 424.712L422.743 424.444C430.14 423.72 437.11 420.642 442.631 415.661C448.153 410.681 451.934 404.06 453.421 396.771Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.004 424.705L416.723 391.302",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.941 424.712C419.941 424.712 414.726 399.738 397.534 401.398",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.867 403.2C428.996 402.126 437.627 393.373 437.627 393.373",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M440.901 368.731C440.407 363.515 438.515 358.529 435.424 354.301C432.334 350.073 428.159 346.759 423.342 344.71C418.507 342.626 413.061 342.467 408.113 344.265C409.825 344.541 411.5 345.015 413.102 345.678C417.907 347.745 422.069 351.064 425.157 355.288C428.245 359.513 430.146 364.489 430.661 369.698C432.959 370.152 435.145 371.057 437.093 372.361C439.04 373.665 440.71 375.342 442.007 377.295C443.303 379.248 444.2 381.44 444.646 383.742C445.092 386.044 445.079 388.412 444.606 390.709L443.194 397.774C441.831 404.433 438.547 410.545 433.75 415.355C428.952 420.164 422.85 423.459 416.2 424.833C417.452 424.842 418.702 424.786 419.948 424.663L422.728 424.395C430.119 423.673 437.085 420.604 442.609 415.636C448.133 410.669 451.927 404.064 453.434 396.785L454.846 389.72C455.321 387.424 455.336 385.057 454.89 382.755C454.444 380.454 453.547 378.263 452.25 376.311C450.953 374.359 449.282 372.684 447.334 371.383C445.386 370.081 443.199 369.18 440.901 368.731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.421 396.771L454.833 389.706C455.309 387.409 455.326 385.04 454.881 382.737C454.437 380.434 453.54 378.242 452.243 376.288C450.946 374.334 449.274 372.657 447.325 371.355C445.375 370.053 443.187 369.151 440.887 368.702C440.394 363.486 438.502 358.5 435.411 354.272C432.32 350.044 428.146 346.73 423.329 344.681C419.738 343.148 415.787 342.659 411.931 343.268C408.074 343.878 404.467 345.563 401.522 348.129L400.584 348.984C394.186 354.573 389.213 361.61 386.078 369.509C382.944 377.409 381.737 385.944 382.559 394.404C382.974 398.767 384.248 403.005 386.307 406.873C388.366 410.741 391.17 414.163 394.557 416.941C401.669 422.787 410.801 425.581 419.963 424.712L422.743 424.444C430.14 423.72 437.11 420.642 442.631 415.661C448.153 410.681 451.934 404.06 453.421 396.771Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.803 267.505L422.305 320.626L423.47 332.714L411.204 333.893L410.35 325.013L332.968 279.593L254.258 349.026L61.6171 367.6L60.4526 355.512",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.079 425.151L249.939 419.668",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.869 433.756L160.729 428.273",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M60.4526 355.512L252.939 336.952L331.803 267.505L422.305 320.626L423.47 332.714L411.204 333.893L410.35 325.013L332.968 279.593L255.028 350.044L61.6171 367.6L60.4526 355.512Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_641_228)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.614 181.433C64.6948 153.936 81.5051 98.9434 119.614 98.9434C157.723 98.9434 174.548 153.936 119.614 181.433Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.614 181.433C64.6948 153.936 81.5051 98.9434 119.614 98.9434C157.723 98.9434 174.548 153.936 119.614 181.433Z",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.143 183.553L121.209 182.387C120.727 182.099 120.176 181.947 119.614 181.947C119.052 181.947 118.501 182.099 118.019 182.387L116.085 183.553",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.614 182.387V230.767C119.608 252.309 123.185 273.703 130.2 294.068",
    stroke: "black",
    strokeWidth: 1.26599,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M250.144 539.312C338.6 539.312 410.308 534.681 410.308 528.969C410.308 523.257 338.6 518.626 250.144 518.626C161.688 518.626 89.98 523.257 89.98 528.969C89.98 534.681 161.688 539.312 250.144 539.312Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_641_228",
    x: 350.645,
    y: 69.083,
    width: 71.5957,
    height: 83.8306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.43994,
    dy: -4.21997
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_641_228"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_641_228",
    x: 83.8149,
    y: 98.3103,
    width: 71.604,
    height: 83.8306,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -8.43994,
    dy: -4.21997
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 0 0.839216 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_641_228"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_641_228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 541,
    height: 539.312,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/House.16a608aafaec1d975436945c4a951083.svg";
export { ForwardRef as ReactComponent };